import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "onClick"];
import React from 'react';
import { BadgeWrapper } from '@carnica/ui-kit';
import { motion } from 'framer-motion';
import { IconChevronDown } from '@carnica/graphics';
import { cnBem } from "../../../../shared/lib";
import { Button } from "../../../../shared/ui";
import { useAppSelector, useScrollContext } from "../../../../shared/model";
import { isDev } from "../../../../shared/config";
import { selectUnreadedMessages } from "../../../../entities/message/model";
import styles from "./styles.pcss";
var cnScrollButton = cnBem('scroll-button', styles);
var varinats = {
  hidden: {
    poinerEvents: 'none',
    x: 100,
    opacity: 0
  },
  visible: {
    x: 0,
    opacity: 1,
    poinerEvents: 'all'
  }
};
export var ScrollButton = function ScrollButton(_ref) {
  var className = _ref.className,
    onClick = _ref.onClick,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useScrollContext = useScrollContext(),
    scrollToBottom = _useScrollContext.scrollToBottom,
    isScrollButtonVisible = _useScrollContext.isScrollButtonVisible;
  var badge = useAppSelector(selectUnreadedMessages).length;
  return /*#__PURE__*/React.createElement("div", {
    className: cnScrollButton(null, [className])
  }, /*#__PURE__*/React.createElement(motion.div, _extends({}, otherProps, {
    animate: isScrollButtonVisible ? 'visible' : 'hidden',
    initial: "hidden",
    transition: {
      x: {
        duration: 0.3
      },
      opacity: {
        duration: 0.3
      }
    },
    variants: varinats
  }), /*#__PURE__*/React.createElement(BadgeWrapper, {
    className: cnScrollButton('button', {
      withoutBadge: !badge || !isDev
    }),
    content: isDev && badge ? badge === null || badge === void 0 ? void 0 : badge.toString() : undefined,
    offset: {
      horizontal: -14,
      vertical: 6
    }
  }, /*#__PURE__*/React.createElement(Button, {
    "aria-label": "\u041F\u0440\u043E\u0441\u043A\u0440\u043E\u043B\u043B\u0438\u0442\u044C \u0432\u043D\u0438\u0437",
    className: cnScrollButton('action-button'),
    "data-count": isDev ? 1 : undefined,
    iconLeft: IconChevronDown,
    onClick: function onClick() {
      return scrollToBottom();
    },
    onlyIcon: true,
    size: "m",
    view: "tertiary-invert"
  }))));
};